import { apiGet, apiPost, apiSend } from './api';

// ---- Закуп · склад ----
export type RawTile = {
  id: number;
  name: string;
  qty: number;
  min: number;
  unit: string;
  short: boolean;
  step: number;
};
export type PoRow = {
  id: number;
  what: string;
  status: string;
  supplier: string | null;
  deal_no: string | null;
  qty: string | null;
  qty_label: string | null;
  amount: number | null;
  raw_id: number | null;
  qty_num: number | null;
  next: string | null;
};
export type Supplier = { id: number; name: string; country: string; cat: string };
export type DealRef = { id: number; no: string };
export type StockMove = {
  id: number;
  raw_name: string;
  unit: string;
  delta: number;
  kind: string;
  at: string;
  deal_no: string | null;
  user_name: string | null;
};
export type PlanRow = {
  component: string;
  need: number;
  deals: string[];
  raw_id: number | null;
  raw_name: string | null;
  on_stock: number | null;
  unit: string | null;
  deficit: number | null;
};
export type SupplyOverview = {
  flow: string[];
  raw: RawTile[];
  po: PoRow[];
  suppliers: Supplier[];
  deals: DealRef[];
  movements: StockMove[];
  plan: PlanRow[];
};
export const supplyOverview = () => apiGet<SupplyOverview>('/api/supply/overview');
export const rawReceive = (id: number, body: { qty?: number; deal_id?: number | null } = {}) =>
  apiPost(`/api/supply/raw/${id}/receive`, body);
export const rawIssue = (id: number, body: { qty?: number; deal_id?: number | null } = {}) =>
  apiPost(`/api/supply/raw/${id}/issue`, body);
export const poAdvance = (id: number) => apiPost(`/api/supply/po/${id}/advance`);
export const createPO = (body: {
  supplier_id?: number;
  what: string;
  deal_id?: number | null;
  qty?: string;
  amount?: number;
  raw_id?: number | null;
  qty_num?: number;
}) => apiPost<{ ok: boolean; id: number }>('/api/supply/po', body);

// Справочник склада (позиции сырья).
export const createRaw = (body: { name: string; unit?: string; min?: number; qty?: number }) =>
  apiPost<{ ok: boolean; id: number }>('/api/supply/raw', body);
export const patchRaw = (id: number, body: { name?: string; unit?: string; min?: number }) =>
  apiSend('PATCH', `/api/supply/raw/${id}`, body);
export const deleteRaw = (id: number) => apiSend('DELETE', `/api/supply/raw/${id}`);

// Справочник поставщиков.
export const createSupplier = (body: { name: string; country?: string; cat?: string }) =>
  apiPost<{ ok: boolean; id: number }>('/api/supply/suppliers', body);
export const patchSupplier = (
  id: number,
  body: { name?: string; country?: string; cat?: string },
) => apiSend('PATCH', `/api/supply/suppliers/${id}`, body);
export const deleteSupplier = (id: number) => apiSend('DELETE', `/api/supply/suppliers/${id}`);

// ---- Отгрузка ----
export type ShipItem = { id: number; name: string; qty_total: number; qty_shipped: number };
export type PendingTruck = {
  id: number;
  label: string;
  rejected: boolean;
  reject_reason: string | null;
};
export type ShipHead = {
  deal_id: number;
  no: string;
  client: string;
  trucks: number;
  pct: number;
  kpp_pending: number;
  items: ShipItem[];
  pending_trucks: PendingTruck[];
};
export type ShipReady = { id: number; no: string; client: string };
export type ShipOverview = { ready: ShipReady[]; ships: ShipHead[] };
export const shipOverview = () => apiGet<ShipOverview>('/api/ship/overview');
export const shipStart = (dealId: number) => apiPost(`/api/ship/${dealId}/start`);
export const shipLine = (dealId: number, itemId: number, all: boolean) =>
  apiPost(`/api/ship/${dealId}/line/${itemId}`, { all });
export const shipTruck = (
  dealId: number,
  body: { plate?: string; driver?: string; lines: { itemId: number; qty: number }[] },
) => apiPost(`/api/ship/${dealId}/truck`, body);
// Отмена ошибочно отправленной машины (роль «Отгрузка», пока машина не выпущена).
export const shipCancelTruck = (dealId: number, kppId: number) =>
  apiSend('DELETE', `/api/ship/${dealId}/truck/${kppId}`);
// Правка идентификации отправленной (не выпущенной) машины.
export const shipEditTruck = (
  dealId: number,
  kppId: number,
  body: { plate?: string; driver?: string },
) => apiSend('PATCH', `/api/ship/${dealId}/truck/${kppId}`, body);
export const shipClose = (dealId: number) => apiPost(`/api/ship/${dealId}/close`);

// ---- КПП ----
export type KppRow = {
  id: number;
  what: string;
  deal_no: string;
  truck: string;
  ok: number;
  at: string;
  rejected: number;
  reject_reason: string | null;
};
export const kppOverview = () => apiGet<{ log: KppRow[] }>('/api/kpp/overview');
// Охрана отклоняет машину с комментарием (пока не выпущена).
export const kppReject = (id: number, reason: string) =>
  apiSend('POST', `/api/kpp/${id}/reject`, { reason });
export const kppOk = (id: number) => apiPost(`/api/kpp/${id}/ok`);
